// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__BOJtF","calendarButtons":"ClockData_calendarButtons__RKRsI"};